/*
  WARNING: Stage option will redirect all requests and authorizations to stage env
 */

const STAGE = false;
// const BYPASS_CACHE = true;

// stage available only on dev environment
export const IS_DEVELOPMENT = process.env.NODE_ENV === 'development';

export const meta = {
  name: 'Banner',
  alias: 'banner',
  stage: STAGE && IS_DEVELOPMENT
};
